import theme from "src/styles/theme";
import styled, { css } from "styled-components";

export const StyledInputWrapper = styled.div<{
  withPlaceholder: boolean;
  error: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;

  > *:not(label):not(p) {
    width: 100%;
    color: ${theme.colors.primary};
    border: 2px solid ${theme.colors.primary};
    border-radius: 8px;
    padding: 0 16px;
    outline: none;
    margin: ${({ withPlaceholder }) => (withPlaceholder ? "0 0 4px" : "4px 0")};
  }

  ~ .form-input {
    margin-top: 0.889em;
  }

  ${({ error }) =>
    error &&
    css`
      > *:not(label):not(p) {
        border: 2px solid ${({ theme }) => theme.colors.error};
      }
    `}
`;

export const InputErrorParagraph = styled.p`
  color: ${theme.colors.error};
  font-size: var(--fs-xxxs);
  line-height: var(--lh-xs);
  min-height: var(--lh-xs);
  margin-bottom: 4px;
`;
